export default __webpack_public_path__ + "static/media/logo.90411622.svg";